export default __webpack_public_path__ + "static/media/social-sharing.d8f83f92.svg";